import React from 'react'
import { Container, Box, Typography, Stack } from '@mui/material'

/**
 * PrivatePageSection
 * Wrapper composicional mínimo para páginas privadas estándar.
 *
 * Props:
 * - title: string (requerido)
 * - subtitle: string (opcional)
 * - actions: ReactNode (opcional)
 * - children: ReactNode (requerido)
 */
const PrivatePageSection = ({ title, subtitle, actions, children }) => {
  return (
    <Container sx={{ py: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          {title}
        </Typography>

        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      {actions ? (
        <Stack
          direction="row"
          spacing={1.5}
          useFlexGap
          sx={{ flexWrap: 'wrap', mb: 2 }}
        >
          {actions}
        </Stack>
      ) : null}

      <Box>{children}</Box>
    </Container>
  )
}

export default PrivatePageSection
